import { defineComponent as _defineComponent } from 'vue';
import { watchImmediate } from "@vueuse/core";
import { BAlert } from "bootstrap-vue";
import { computed, ref } from "vue";
import Multiselect from "vue-multiselect";
import { GalaxyApi } from "@/api";
import {} from "@/api/schema";
import { errorMessageAsString } from "@/utils/simple-error";
import License from "@/components/License/License.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LicenseSelector',
    props: {
        inputLicense: null
    },
    emits: ["onLicense"],
    setup(__props, { emit }) {
        const props = __props;
        const defaultLicense = {
            licenseId: null,
            name: "*Do not specify a license.*",
        };
        const licensesLoading = ref(false);
        const errorMessage = ref("");
        const currentLicense = ref();
        const licenses = ref([]);
        const licenseOptions = computed(() => {
            const options = [];
            options.push(defaultLicense);
            for (const license of licenses.value || []) {
                if (license.licenseId == currentLicense.value?.licenseId || license.recommended) {
                    options.push({
                        licenseId: license.licenseId,
                        name: license.name,
                    });
                }
            }
            return options;
        });
        function onLicense(license) {
            emit("onLicense", license.licenseId);
        }
        async function fetchLicenses() {
            const { error, data } = await GalaxyApi().GET("/api/licenses");
            if (error) {
                errorMessage.value = errorMessageAsString(error) || "Unable to fetch licenses.";
            }
            licenses.value = data;
            licensesLoading.value = false;
        }
        async function setCurrentLicense() {
            if (!licenses.value?.length && !licensesLoading.value) {
                licensesLoading.value = true;
                await fetchLicenses();
            }
            const inputLicense = props.inputLicense;
            currentLicense.value = (licenses.value || []).find((l) => l.licenseId == inputLicense) || defaultLicense;
        }
        watchImmediate(() => props.inputLicense, () => {
            setCurrentLicense();
        });
        return { __sfc: true, defaultLicense, props, emit, licensesLoading, errorMessage, currentLicense, licenses, licenseOptions, onLicense, fetchLicenses, setCurrentLicense, BAlert, Multiselect, License, LoadingSpan };
    }
});
